import { Box, styled } from '@mui/system'

const SidebarNavAccordeonMenu = styled(Box)(({ theme }) => ({
	borderLeft: `2px solid ${theme.palette.grey[200]}`,
	marginLeft: '1rem',
	marginTop: '0.5rem',
	paddingLeft: '1.5rem',
}))

export { SidebarNavAccordeonMenu }
